module.exports = __webpack_public_path__ + "static/media/wait.993ef49f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/loader/wait.svg
// module id = 971
// module chunks = 0